import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { reviewsApi } from 'api/reviews'
import { EReviewStatus } from 'models/review'
import { IReviewsState } from './types'

const initialState: IReviewsState = {
  pendingCount: 0
}

// Бейджу нужно только общее число из count, поэтому сам список — из одного отзыва
export const getPendingReviewsCount = createAsyncThunk(
  'reviews/getPendingReviewsCount',
  async () => {
    const response = await reviewsApi.getList({
      skip: '0',
      limit: '1',
      statuses: [EReviewStatus.PENDING]
    })
    return response.data.count
  }
)

const reviewsSlice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPendingReviewsCount.fulfilled, (state, action) => {
        state.pendingCount = action.payload
      })
      .addCase('app/logout', () => initialState)
  }
})

export default reviewsSlice.reducer
